module.exports = __webpack_public_path__ + "static/img/kongxincai.a5b9db10.png";